import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["header", "safeArea", "userMenu", "userMenuButton", "helpMenu", "helpButton"]
  static values = {
    showTabs: { type: Boolean, default: true },
    fromOutside: { type: Boolean, default: false },
  }

  connect() {
    // Check if the mouse is on the header on load, to avoid the menu to expand
    document.addEventListener(
      "mousemove",
      (e) => {
        var t = this.headerTarget
        var mouseX = e.clientX + document.body.scrollLeft

        if (mouseX > t.getBoundingClientRect().left + t.getBoundingClientRect().width) {
          this.fromOutsideValue = true
        }
      },
      { once: true },
    )
  }

  expandNavigation() {
    if (this.fromOutsideValue) {
      this.expandTimeout = setTimeout(() => {
        this.headerTarget.classList.add("is-expanded")
      }, 150)
    }
  }

  resetFromOutside() {
    clearTimeout(this.expandTimeout)
    this.headerTarget.classList.remove("is-expanded")
    this.fromOutsideValue = true
  }

  // User Menu
  //
  toggleUserMenu() {
    this.userMenuButtonTarget.classList.toggle("is-active")
    this.userMenuTarget.classList.toggle("is-open")
    this.userMenuTarget.focus()
  }

  closeUserMenu(e) {
    if (e && (this.userMenuTarget.contains(e.target) || this.userMenuButtonTarget.contains(e.target))) {
      return
    }

    this.userMenuTarget.classList.remove("is-open")
    this.userMenuButtonTarget.classList.remove("is-active")
  }

  // Help
  //
  toggleHelp() {
    this.helpButtonTarget.classList.toggle("is-active")
    this.helpMenuTarget.classList.toggle("is-open")
    this.helpMenuTarget.focus()
  }

  closeHelp(e) {
    if (e && this.helpButtonTarget.contains(e.target)) {
      return
    }

    this.helpMenuTarget.classList.remove("is-open")
    this.helpButtonTarget.classList.remove("is-active")
  }
}
